<button *ngIf="!useLinkButton"
        mat-raised-button
        color="primary"
        [ngClass]="ngClass"
        [routerLink]="routerLink"
>
  <mat-icon class="valign-middle">visibility</mat-icon>
  Preview
</button>
<a *ngIf="useLinkButton" [ngClass]="ngClass" [routerLink]="routerLink">
  <mat-icon class="valign-middle">visibility</mat-icon>
</a>
